import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import cx from 'classnames';
import Link from 'next/link';
import useInterval from '../../../utils/useInterval';
import Box from '@material-ui/core/Box';
import Wrap from './Wrap';

const img1 = '/depv/gallery/Fotolia_18793167_L.jpg';
const img2 = '/depv/gallery/DEPI_Pellet-LKW_Reichstag.jpg';
const img3 =
  '/depv/gallery/DEPI_Pellets_Briketts_Hackschnitzel_weisserHintergrund.jpg';
const img4 = '/depv/gallery/DEPI_Wald_4.jpg';

const images = [img1, img2, img3, img4];

images.push(img1);
images.push(img2);
images.unshift(img4);
images.unshift(img3);

const TRANSITION_TIME = '1500ms';
const INTERVAL_DELAY = 3000;
const MIN_HEIGHT = 450;

const useStyles = makeStyles(theme => ({
  galleryWrap: {
    width: '100%',
    minHeight: MIN_HEIGHT,
    overflow: 'hidden',
  },
  slide: {
    backgroundSize: 'cover',
    backgroundPosition: 'center',
    position: 'absolute',
    minWidth: '100%',
    minHeight: MIN_HEIGHT,
    '&:after': {
      top: 0,
      left: 0,
      position: 'absolute',
      display: 'block',
      opacity: 0.0,
      backgroundColor: theme.palette.common.white,
      minWidth: '100%',
      minHeight: '100%',
      content: '""',
    },
  },
  animated: {
    transition: `transform ${TRANSITION_TIME}`,
    '&:after': {
      transition: `opacity ${TRANSITION_TIME}`,
    },
  },
  gallery: {
    position: 'relative',
    minHeight: MIN_HEIGHT,
    width: '100%',
    // cursor: 'pointer',
  },
  off: {
    '&:after': {
      opacity: 0.8,
    },
  },
}));

const GalleryImage = (
  image,
  position,
  offset,
  isMain,
  animateSlider,
  resetFunc,
) => {
  const translate = 100 * (position - offset);
  const classes = useStyles();
  return (
    <div
      key={position}
      className={cx(
        classes.slide,
        !isMain && classes.off,
        animateSlider && classes.animated,
      )}
      onTransitionEnd={resetFunc}
      style={{
        backgroundImage: `url(${image})`,
        transform: `translate(${translate}%, 0)`,
      }}
    />
  );
};

const GallerySection = () => {
  const classes = useStyles();
  const [galleryState, setGalleryState] = React.useState({
    offset: 2,
    animateSlider: true,
    direction: null,
    autoCycle: true,
  });

  useInterval(() => {
    if (galleryState.autoCycle) {
      const newOffset = galleryState.offset + 1;
      // if (newOffset > images.length - 1) newOffset = 0;
      setGalleryState({
        ...galleryState,
        animateSlider: true,
        offset: newOffset,
        direction: 'right',
      });
    }
  }, INTERVAL_DELAY);

  const handleResetGallery = () => {
    const { offset, animateSlider, direction } = galleryState;
    if (offset >= images.length - 2 && animateSlider && direction === 'right') {
      const newOffset = 2;
      setGalleryState({
        ...galleryState,
        animateSlider: false,
        offset: newOffset,
      });
    }
    if (offset <= 2 && animateSlider && direction === 'left') {
      const newOffset = images.length - 2;
      setGalleryState({
        ...galleryState,
        animateSlider: false,
        offset: newOffset,
      });
    }
  };

  return (
    <Wrap maxWidth={1020} noPadding className={cx(classes.galleryWrap)}>
      <Box className={classes.gallery}>
        {images.map((image, index) =>
          GalleryImage(
            image,
            index,
            galleryState.offset,
            index - galleryState.offset === 0,
            galleryState.animateSlider,
            handleResetGallery,
          ),
        )}
      </Box>
    </Wrap>
  );
};

export default GallerySection;
